import { createLogCustom } from '../../../../backend/features/audit';
import { addMembersToOrganizationBulkActionEvent } from '../../../../backend/features/audit/shared';
import { organizationEntityName, orgColumnForAuditIdReplacement, } from '../../../../backend/features/organizations/shared';
import { getDefaultOrgRole } from '../../../../backend/features/organizations/shared/getDefaultOrgRole';
import { allowOrgMembersEdit, getAccountsViewFilterNew, requireAnySystemPermission } from '../../../../backend/features/permissions/shared';
import { forEachEntityRow } from '../../../../backend/utils';
import { getErrorMessage } from '../../../../backend/utils/getErrorMessage';
import { AuthError } from '@juvare/platform-app/App';
import { defineBulkAction } from '@juvare/platform-sdk-react/backend/features/bulk-actions';
import { addAccountsToOrganizationBulkActionType } from '../shared';
import { getAccountStorage } from '../utils/getAccountStorage';
import { transformOrgColumnIntoDataObject } from '../utils/transformOrgColumnIntoDataObject';
export const addAccountsToOrganization = defineBulkAction({
    type: addAccountsToOrganizationBulkActionType,
    onAuthBulkAction: (userContext, { data }) => {
        if (!allowOrgMembersEdit(userContext.userState)) {
            throw new AuthError('Unauthorized');
        }
        return {
            secureFilter: [
                ...getAccountsViewFilterNew(userContext.userState, requireAnySystemPermission(userContext.userState, 'manage-accounts-organizations')),
                ...data.params.filter,
            ],
        };
    },
    onProcessBulkAction: (appContext, { data, isCancelled, updateTotalCount, updateProcessedCount }) => {
        const accountStorage = getAccountStorage(appContext);
        const defaultRole = getDefaultOrgRole(appContext.appState.settings.orgRoleMap);
        const ids = [];
        forEachEntityRow(accountStorage, { filter: data.secureParams.secureFilter, orderBy: [{ column: 'email' }] }, (row, idx) => {
            var _a;
            try {
                const orgRoles = transformOrgColumnIntoDataObject(row.columns.orgRole);
                const orgStatuses = transformOrgColumnIntoDataObject(row.columns.orgStatus);
                let shouldUpdate = false;
                if (data.params.accountRejectedOrganizationsMap) {
                    if ((_a = data.params.accountRejectedOrganizationsMap[row.id]) === null || _a === void 0 ? void 0 : _a.includes(data.params.organizationId)) {
                        console.warn(`Account id=${row.id} violates account membership limit in organization id=${data.params.organizationId}`);
                    }
                    else {
                        shouldUpdate = true;
                    }
                }
                else if (!orgRoles[data.params.organizationId]) {
                    shouldUpdate = true;
                }
                if (shouldUpdate) {
                    accountStorage.post({
                        action: 'partial-update',
                        id: row.id,
                        data: {
                            orgRole: Object.assign(Object.assign({}, orgRoles), { [data.params.organizationId]: defaultRole || 'user' }),
                            orgStatus: Object.assign(Object.assign({}, orgStatuses), { [data.params.organizationId]: 'accepted' }),
                        },
                        actionParams: {
                            bulkAction: true,
                        },
                    });
                }
                ids.push(row.id);
            }
            catch (error) {
                console.error('Failed to process addAccountsToOrganization bulk action', data.params, getErrorMessage(error));
            }
            updateProcessedCount(idx + 1);
            return { cancel: isCancelled() };
        }, updateTotalCount);
        const orgStorage = appContext.storage(organizationEntityName);
        const organization = orgStorage.get(data.params.organizationId);
        const logCustomStrict = createLogCustom(appContext.audit);
        logCustomStrict({
            eventType: addMembersToOrganizationBulkActionEvent,
            entity: organizationEntityName,
            entityId: organization.id,
            params: {
                ids,
                orgStatus: 'accepted',
                orgRole: defaultRole || 'user',
                auditColumnValue: organization.columns[orgColumnForAuditIdReplacement],
            },
        });
    },
});
